<template>
  <div class="print-detail">
    <div v-if="hasCode">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <template v-for="searchItem in searchList">
          <el-form-item :key="searchItem.prop">
            <component
              :is="'search-' + searchItem.type"
              :items="searchItem.items"
              v-model="searchForm[searchItem.prop]"
              @search="search"
              :attrs="searchItem.attrs"
            />
          </el-form-item>
        </template>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="clear">清空</el-button>
        </el-form-item>
      </el-form>
      <div>
        <TableTopBtns style="display: inline-block;" :btns="btnList" @click="topBtnsClick" />
        <div style="display: inline-block;">
          <span class="ml_20">商品名:{{ '丝织展精美连衣裙' }}</span>
          <span class="ml_20">款式编码:{{ 123234343543543 }}</span>
        </div>
      </div>
      <div class="content">
        <TableList ref="table" :cols="cols" :list="list" selection :height="400" @selection-change="selectionChange">
          <template slot="pictureSlot" slot-scope="{ row }">
            <div style="display: flex; align-items: center">
              <ListLazyImg :size="{width: 35, height: 35}" :src="`${row.picture}`" />
            </div>
          </template>
          <template slot="code" slot-scope="{ row }">
            <p>唯一码：{{ row.code }}</p>
            <p>流水号：{{ row.code }}</p>
          </template>
        </TableList>
        <el-pagination
          :style="{ padding: '8px 16px', textAlign: 'right' }"
          :current-page="pageData.pageNo"
          :page-sizes="[10, 20, 50, 100, 150]"
          :page-size="pageData.pageSize"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
        >
        </el-pagination>
      </div>
    </div>
    <div v-else>
      <noCodeContent :info="noCodeData"></noCodeContent>
    </div>
  </div>
</template>

<script>
import SearchSelect from '@/components/prod/center/components/SearchSelect.vue';
import SearchInput from '@/components/prod/center/components/SearchInput.vue';
import TableTopBtns from '@/components/prod/center/TableTopBtns.vue';
import TableList from '@/components/TableList.vue';
import ListLazyImg from '@/components/ListLazyImg/index.vue';
import noCodeContent from './noCodeContent.vue';
import { searchList, colList, btnList } from './dictionary';

export default {
  components: { SearchSelect, SearchInput, TableList, TableTopBtns, ListLazyImg, noCodeContent },

  props: {
    tab: {
      type: String,
      default: 'print',
    },
  },
  data() {
    return {
      hasCode: true,
      btnList,
      searchList,
      cols: [],
      searchForm: {
        searchType: 'weiyima',
        content: '',
      },
      pageData: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      selectRows: [],
      list: [
      
      ],
      noCodeData: {}
    };
  },
  watch: {
    print: {
      handler(tab) {
        let unvisibleList = [];
        if (tab === 'print') {
          unvisibleList = ['num'];
        }
        this.cols = colList(unvisibleList);
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    search() {
      let params = {
        ...this.searchForm,
        pageNo: this.pageData.pageNo,
        pageSize: this.pageData.pageSize,
      };
    },
    clear() {
      this.pageData.pageNo = 1;
      this.searchForm = {
        purchaseName: '',
        level: '',
      };
      this.search();
    },
    topBtnsClick(eventName) {},
    selectionChange(selection) {
      this.selectRows = selection;
    },
    pageSizeChange(size) {
      this.pageData.pageNo = 1;
      this.pageData.pageSize = size;
      this.search();
    },
    pageChange(page) {
      this.pageData.pageNo = page;
      this.search();
    },
  },
};
</script>

<style lang="scss" scoped>
.print-detail {
  .el-form-item {
    margin: 0px 4px 6px 0px;
  }
  .ml_10 {
    margin-left: 10px;
  }
  .ml_20 {
    margin-left: 20px;
  }
  .mr_10 {
    margin-right: 10px;
  }
  .fr {
    float: right;
  }
}
</style>
